import axios from "axios";
import { LoginResponse, Admin } from "../types/auth";

const API_URL = process.env.REACT_APP_API_URL || "";

// Create axios instance with interceptors for authentication
const apiClient = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling token expiration
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Logout on 401 Unauthorized
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminInfo");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const authApi = {
  login: async (identifier: string, password: string): Promise<LoginResponse> => {
    const response = await apiClient.post("/api/admin/auth/login", {
      email: identifier,
      password,
    });

    if (response.data.token) {
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminInfo", JSON.stringify(response.data.admin));
    }

    return response.data;
  },

  logout: async () => {
    try {
      // Calling backend logout endpoint if it exists
      await apiClient.post("/api/admin/auth/logout");
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminInfo");
    }
  },

  getCurrentAdmin: async (): Promise<Admin> => {
    const response = await apiClient.get("/api/admin/auth/me");
    return response.data;
  },

  updatePassword: async (currentPassword: string, newPassword: string) => {
    const response = await apiClient.put("/api/admin/auth/password", {
      currentPassword,
      newPassword,
    });
    return response.data;
  },
};

export default authApi;
